import useSWR from 'swr'
import { GetMetadataFetcher, GetStaticMetaFile } from './MetadataFetchers'

export enum MetadataServicePath {
  GetStaticMetadata = 'get-static-metadata',
  GetMetadata = '/country?includeCity=true&includeDistrict=true',
  GetCountries = '/country?includeCity=false&includeDistrict=false',
}

export default {
  getStaticMetaFile: () =>
    useSWR(MetadataServicePath.GetStaticMetadata, GetStaticMetaFile, {
      revalidateOnMount: true,
    }),
  getMetadata: () =>
    useSWR(MetadataServicePath.GetMetadata, GetMetadataFetcher, {
      revalidateOnMount: true,
    }),
  getRoutes: () =>
    useSWR(MetadataServicePath.GetMetadata, GetMetadataFetcher, {
      revalidateOnMount: false,
      revalidateIfStale: false,
    }),
  getCountries: () =>
    useSWR(MetadataServicePath.GetCountries, GetMetadataFetcher, {
      revalidateOnMount: false,
      revalidateIfStale: false,
    }),
  getPrefix: (countryId: string) =>
    useSWR(`/country/${countryId}/prefix`, GetMetadataFetcher, {
      revalidateOnMount: false,
      revalidateIfStale: false,
    }),
  getRegions: (countryId: string) =>
    useSWR(`/country/${countryId}/region?includeZipCodePrefix=true`, GetMetadataFetcher, {
      revalidateOnMount: false,
      revalidateIfStale: false,
    }),
  getContracts: (countryId: string, tenantType = 'CARRIER') =>
    useSWR(`/contract/current?countryId=${countryId}&tenantType=${tenantType}`, GetMetadataFetcher, {
      revalidateOnMount: true,
      revalidateIfStale: true,
    }),
}
